import { Moment } from 'moment'

export const consumptionItemKey = 'YYYYMMDDHHmm'

type Item = { [YYYYMMDDHHmm: string]: number }

export type ConsumptionData = {
  currentConsumption: number
  co2Emission: number
  items: Item
}

export default class Consumption {
  declare currentConsumption: number
  declare co2Emission: number
  declare items: Item

  constructor(params: ConsumptionData) {
    Object.assign(this, params)
  }

  getItem(date: Moment): number | null {
    return this.items[date.format(consumptionItemKey)] ?? null
  }
}
